import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { attorneyAuth } from './api'
import { Signup } from './screens/Signup'
import { Login } from './screens/Login'
import { Portal } from './screens/Portal'
import { VerifyAttorney } from './screens/VerifyAttorney'
import { BoardReview } from './screens/BoardReview'
import { FoundingReview } from './screens/FoundingReview'
import { Home } from './screens/Home'
import { IntakeAI } from './screens/IntakeAI'
import { Advertising } from './screens/Advertising'
import { Board } from './screens/Board'
import { Pricing } from './screens/Pricing'
import { Contact } from './screens/Contact'

function RequireAttorney({ children }) {
  return attorneyAuth.isAuthenticated() ? children : <Navigate to="/login" replace />
}

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    const go = () => {
      if (hash) {
        const el = document.getElementById(hash.slice(1))
        if (el) {
          const header = document.querySelector('header')
          const offset = (header ? header.offsetHeight : 0) + 12
          window.scrollTo(0, el.getBoundingClientRect().top + window.scrollY - offset)
          return
        }
      }
      window.scrollTo(0, 0)
    }
    // Retry a few times: the new route's layout (and its anchor) may not be
    // measurable on the first tick. ponytail: fixed schedule covers text pages;
    // a ResizeObserver would be exact if a page ever gains slow-loading media.
    const timers = [0, 60, 200].map((d) => setTimeout(go, d))
    return () => timers.forEach(clearTimeout)
  }, [pathname, hash])
  return null
}

export default function AttorneyApp() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/intake-ai" element={<IntakeAI />} />
        <Route path="/della" element={<Navigate to="/intake-ai" replace />} />
        <Route path="/advertising" element={<Advertising />} />
        <Route path="/board" element={<Board />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify/:token" element={<VerifyAttorney />} />
        <Route path="/board-review/:token" element={<BoardReview />} />
        <Route path="/founding-review/:token" element={<FoundingReview />} />
        <Route path="/portal" element={<RequireAttorney><Portal /></RequireAttorney>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
